import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Watch from 'src/views/watch';

const RootRouter = props => {
  return (
    <BrowserRouter>
      <Routes >
        <Route path="/watch" Component={Watch} />
        <Route path="/" element={<Navigate to="/watch" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RootRouter;
